import { LoadingSpinner } from "@/design-system/components/LoadingSpinner/LoadingSpinner";

// Rendered on the first frame so a resolved state never flashes into another.
export function CroSplashLoadingPlaceholder() {
  return (
    <div
      className="flex h-full min-h-[500px] w-full items-center justify-center"
      data-testid="cro-splash-loading-placeholder"
      aria-busy="true"
      aria-live="polite"
    >
      <LoadingSpinner className="size-10" />
    </div>
  );
}
